import React from 'react';
import { Link } from 'react-router-dom';

interface BrandMarkProps {
  to?: string;
  compact?: boolean;
  onPaper?: boolean;
}

const BrandMark: React.FC<BrandMarkProps> = ({ to = '/', compact = false, onPaper = false }) => {
  const content = (
    <span className="inline-flex items-center gap-2.5">
      <span
        className={`flex items-center justify-center rounded-md ${
          compact ? 'h-8 w-8' : 'h-9 w-9'
        } ${onPaper ? 'bg-forest-600 text-white' : 'bg-forest-600 text-white'}`}
        aria-hidden
      >
        <svg viewBox="0 0 24 24" className={compact ? 'h-4 w-4' : 'h-5 w-5'} fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="M5 5.5A2.5 2.5 0 0 1 7.5 3H19v16H7.5A2.5 2.5 0 0 0 5 21.5V5.5Z" />
          <path d="M5 19.5A2.5 2.5 0 0 1 7.5 17H19" />
        </svg>
      </span>
      <span className={`font-serif tracking-tight ${compact ? 'text-lg' : 'text-xl'} text-ink`}>
        BookShare
      </span>
    </span>
  );

  if (to) {
    return (
      <Link to={to} className="hover:opacity-80 transition-opacity">
        {content}
      </Link>
    );
  }

  return content;
};

export default BrandMark;
